// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yJawp","colBig":"styles_colBig__1a81Y","colSmall":"styles_colSmall__1D5FU"};